import { useParams } from 'react-router-dom';
import config from '../../../../../config/channels';
import useGroupContext from '../../../../../contexts/group/useGroupContext';
import { shareLink } from '../../../../../services/groupOrder';

// The link to the group order we're in: straight onto the site's menu, to join
const useShareLink = (): string => {
    const groupContext = useGroupContext();
    const { restaurant_id } = useParams();

    if (!groupContext.session) return '';

    return shareLink(
        window.location.origin,
        config.catering.handle,
        restaurant_id ?? groupContext.session.siteUid,
        groupContext.session.token
    );
};

export default useShareLink;
